import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Contact from '@/pages/home/components/Contact';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL ?? 'https://grainn-office.com';

const contactJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'ContactPage',
      '@id': `${siteUrl}/contact#webpage`,
      url: `${siteUrl}/contact`,
      name: '大阪 経営コンサルティング 無料相談・お問い合わせ｜GRAINN',
      description: 'GRAINNへのお問い合わせはこちら。WEBサイト制作・SNS運用代行・デジタルマーケティングの初回相談は無料です。大阪・全国オンライン対応可能。',
      inLanguage: 'ja',
      isPartOf: { '@id': `${siteUrl}/#website` },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: 'ホーム', item: `${siteUrl}/` },
          { '@type': 'ListItem', position: 2, name: 'お問い合わせ', item: `${siteUrl}/contact` },
        ],
      },
    },
  ],
};

export default function ContactPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="min-h-screen">
      <title>大阪 経営コンサルティング 無料相談・お問い合わせ｜GRAINN</title>
      <meta name="description" content="GRAINNへのお問い合わせはこちら。WEBサイト制作・SNS運用代行・デジタルマーケティングの初回相談は無料です。大阪・全国オンライン対応可能。" />
      <link rel="canonical" href={`${siteUrl}/contact`} />
      <JsonLd data={contactJsonLd} id="contact" />
      <Navbar />

      {/* Page Hero */}
      <section
        className="relative pt-44 pb-24 overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #0A2A6E 0%, #0D3A8E 50%, #1557C0 100%)' }}
      >
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20dark%20navy%20blue%20digital%20technology%20background%20with%20glowing%20blue%20circuit%20lines%20and%20data%20streams%2C%20futuristic%20cyber%20grid%20pattern%2C%20electric%20blue%20light%20particles%20floating%20in%20darkness%2C%20ultra%20modern%20IT%20company%20aesthetic%2C%20deep%20space%20dark%20blue%20atmosphere%20with%20luminous%20blue%20geometric%20shapes%2C%20premium%20tech%20startup%20visual%20identity%2C%20cinematic%20wide%20angle%2C%20no%20people%2C%20highly%20stylized&width=1920&height=600&seq=contact-hero-blue-bg&orientation=landscape"
            alt="お問い合わせ"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(10,42,110,0.5), rgba(10,42,110,0.82))' }} />
        </div>
        <div
          className="absolute inset-0 opacity-[0.06]"
          style={{
            backgroundImage: 'linear-gradient(rgba(255,255,255,0.35) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.35) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />
        <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
          <p className="text-[#93C5FD] text-xs tracking-[0.4em] mb-5 uppercase">/ Contact</p>
          <h1 className="text-5xl md:text-7xl font-bold text-white tracking-tight leading-tight mb-6">
            お問い合わせ
          </h1>
          <div className="w-16 h-px mb-6" style={{ background: 'linear-gradient(90deg, #60A5FA, transparent)' }} />
          <p className="text-white/70 text-lg max-w-xl leading-relaxed">
            初回ご相談は無料です。お気軽にご連絡ください。
          </p>
          <div className="flex items-center gap-2 mt-8 text-xs text-white/40">
            <Link to="/" className="hover:text-white/70 transition-colors">ホーム</Link>
            <i className="ri-arrow-right-s-line" />
            <span className="text-white/70">お問い合わせ</span>
          </div>
        </div>
      </section>

      <Contact />
      <Footer />
    </main>
  );
}
